import { Button } from 'components/atoms'
import { type FC } from 'react'
import styled from 'styled-components'
import { colors } from 'theme'
import { type Plan } from 'types/graphql'

import RecapItem from './RecapItem'

const SubscriptionCard: FC<{
  plan: Plan
  onClick: () => void
}> = ({
  plan,
  onClick,
}) => (
  <Wrapper>
    <Header>
      <HeaderLeft>
        <Title>
          {'Abonnement ' + plan.title}
        </Title>
        <PriceWrapper>
          <PriceInfos>
            { `${plan.metadata.displayPrice}€ ${plan.metadata.taxType} / ${plan.interval === 'year' ? 'an' : 'mois' }` }
          </PriceInfos>
          <PriceInfos>
            {plan.metadata.threshold > 1 ?
              ' par licence'
              : ''
            }
          </PriceInfos>
        </PriceWrapper>
        { plan.metadata.info && (
          <FuturePriceInfos>
            { plan.metadata.info }
          </FuturePriceInfos>
        )}
        <Recap>
          <RecapItem>
            {plan.interval === 'year' ? 'Abonnement annuel' : 'Abonnement mensuel' }
          </RecapItem>
          <RecapItem>
            {plan.metadata.threshold > 1
              ? 'À partir de 2 licences, dont la vôtre'
              : '1 licence'
            }
          </RecapItem>
        </Recap>
      </HeaderLeft>
      <HeaderRight>
        <ChooseLicence
          size="medium"
          variant="primary"
          onClick={ onClick }
        >
          Choisir
        </ChooseLicence>
      </HeaderRight>
    </Header>
  </Wrapper>
)

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const Header = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  padding: 1.125rem;
  padding-bottom: 1.3125rem;
  margin: 0.5rem 2rem 0 -2.5rem;
  background: linear-gradient(114.07deg, #104784 0%, #06264f 100%);
  border-radius: 8px;
`

const HeaderLeft = styled.div`
  display: flex;
  flex-direction: column;
`

const HeaderRight = styled.div`
  display: flex;
  flex-direction: column;
`

const Title = styled.span`
  margin-bottom: 1.3125rem;
  font-family: 'brother-1816';
  font-size: 1.5rem;
  font-style: normal;
  font-weight: 900;
  color: ${colors.white};
  user-select: none;
`

const PriceWrapper = styled.span`
  font-family: Montserrat;
  font-size: 1.125rem;
  font-style: normal;
  font-weight: normal;
  color: ${colors.white};
`

const PriceInfos = styled.span`
  font-family: Montserrat;
  font-weight: 700;
`

const FuturePriceInfos = styled.span`
  margin-top: 1rem;
  font-family: Montserrat;
  font-size: 0.875rem;
  font-style: normal;
  font-weight: 600;
  color: ${colors.yellow};
`

const Recap = styled.div `
  padding: 1rem 0 0;
`

const ChooseLicence = styled(Button)`
  && {
    position: relative;
    justify-content: center;
    width: 1px;
    margin: 0.4rem;
    color: ${colors.lightGreen};
    background-image: none;
    border: 1px solid ${colors.lightGreen};
    box-shadow: none;
  }
`

export default SubscriptionCard
